<template lang="pug">
    div(class="watchlist-charts" style="overflow-y:scroll; position:relative; border: 0px solid green; width: 100%;")
        div(class="card-container")
            div( v-for="(item,index) in watchlists" :key="index" class="card-item" style="border: 0px solid")
                div(class="stn-sdw")
                    div(style="display: flex; justify-content: start; padding-bottom:12px")
                        Ticker(:stockId="item.stock_id")
                        h3(class="card-name") {{ item.Name }}

                    div(class="" style="overflow:hidden; border: 1px solid lightgray")
                        ChartPrice(:stock_id="item.stock_id" :company_id="item.company_id" :toolbar="false" single page="none")
</template>

<script>
import ChartPrice from "../../components/ChartPrice.vue";
import Ticker from "../../components/Ticker.vue";

export default {
    name: "ViewModeGrid",
    props: {
        watchlists: Array
    },
    components: {
        ChartPrice,
        Ticker
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            windowHeight: window.innerHeight
        };
    },
    mounted() {
        this.windowHeight = window.innerHeight;

        window.addEventListener('resize', this.setWindowHeight);
    },
    destroyed() {
        window.removeEventListener('resize', this.setWindowHeight);
    },
    computed: {
        chartWidth() {
            if(this.$refs.mainSection) {
                return Math.round((this.$refs.mainSection.clientWidth-100)/3);
            }

            return 490;
        }
    },
    methods: {
        setWindowHeight() {
            this.windowHeight = window.innerHeight;
        }
    }
}
</script>
